type WindowWithDataLayer = Window & {
  gtag: Function;
};

declare const window: WindowWithDataLayer;

const useAnalyticsEventTracker = () => {
  return (action = "action", params = {}) => window.gtag('event', action, params);
}

export default useAnalyticsEventTracker;
